<template>
  <div class="vx-row">
    <div class="vx-col w-full">
      <vs-tabs>
        <vs-tab label="ข้อมูลค่าธรรมเนียม">
          <FeeInfoTab></FeeInfoTab>
        </vs-tab>
        <vs-tab label="ข้อมูลค่าใช้จ่าย">
          <ExpenseInfoTab></ExpenseInfoTab>
        </vs-tab>
      </vs-tabs>
    </div>
  </div>
</template>

<script>
import FeeInfoTab
  from "@/views/pages/Accounting/Contract/Detail/Components/FeeInfoAndExpenseInfoTab/Components/FeeInfoTab/index.vue";
import ExpenseInfoTab
  from "@/views/pages/Accounting/Contract/Detail/Components/FeeInfoAndExpenseInfoTab/Components/ExpenseInfoTab/index.vue";

export default {
  name: 'FeeInfoAndExpenseInfoTab',
  components: {
    FeeInfoTab,
    ExpenseInfoTab,
  },
}
</script>

<style scoped>
.vx-row {
  margin-bottom: 15px;
}
</style>
